import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';
import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      '&:not(:last-child)': {
        marginBottom: MIDDLE_MARGIN,
        paddingBottom: MIDDLE_MARGIN,
        borderBottom: `1px solid ${fade(colorsPalette.white, 0.33)}`,
      },
    },
    title: {
      color: colorsPalette.white,
      fontWeight: 'bold',
      marginBottom: SMALL_MARGIN,
      paddingBottom: SMALL_MARGIN,
      fontSize: 18,
      lineHeight: '26px',
      borderBottom: `1px solid ${fade(colorsPalette.white, 0.33)}`,
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        lineHeight: '28px',
        borderBottom: 'none',
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    },
    textWrapper: {
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        width: 340,
        maxWidth: 340,
        minWidth: 340,
        marginBottom: 0,
        marginRight: LARGE_MARGIN,
      },
    },
    text: {
      color: colorsPalette.gray,
      fontSize: 16,
      lineHeight: '26px',
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
        lineHeight: '26px',
      },
      '&:not(:last-child)': {
        marginBottom: SMALL_MARGIN,
      },
    },
  }),
);

export default useStyles;
